import { Overlay, Wrapper } from './ScoreWordMarkHover.styles'
import { ScoreWordMark, ScoreWordMarkBlack } from '../../assets'

export interface ScoreWordMarkHoverProps {
  height?: number
}

const ScoreWordMarkHover = ({ height = 24 }: ScoreWordMarkHoverProps) => (
  <Wrapper>
    <ScoreWordMarkBlack height={height} style={{ width: 'auto', display: 'block' }} />
    <Overlay>
      <ScoreWordMark height={height} style={{ width: 'auto', display: 'block' }} />
    </Overlay>
  </Wrapper>
)

export default ScoreWordMarkHover
